<template>
  <component :is="component"></component>
</template>
<script>
import Func14Listagem from '@/views/14/Func14Listagem.vue'

export default {
  name: 'Func14',
  data () {
    return {
      component: Func14Listagem
    }
  }
}
</script>
